import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as Icons from 'react-icons/fa';

const { FaChevronDown, FaChevronUp } = Icons;

const Icon = ({ Component, ...props }: { Component: any; [key: string]: any }) => {
  return <Component {...props} />;
};

interface AccordionCardProps {
  title: string;
  subtitle?: string;
  company?: string;
  icon: any;
  children: React.ReactNode;
  delay?: number;
}

const AccordionCard: React.FC<AccordionCardProps> = ({ 
  title, 
  subtitle, 
  company, 
  icon: IconComponent, 
  children,
  delay = 0 
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay }}
      viewport={{ once: true }}
      className="bg-gradient-to-r from-indigo-500/10 via-purple-500/10 to-indigo-500/10 border border-indigo-500/20 rounded-2xl backdrop-blur-sm overflow-hidden"
    >
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full p-8 flex items-center justify-between hover:bg-indigo-500/5 transition-colors"
      >
        <div className="flex items-center gap-6 flex-1">
          <div className="w-16 h-16 bg-gradient-to-r from-indigo-500 via-purple-500 to-indigo-500 rounded-xl flex items-center justify-center flex-shrink-0">
            <Icon Component={IconComponent} className="text-white text-2xl" />
          </div>
          <div className="flex-1 text-left">
            <h3 className="text-2xl font-semibold text-white mb-1">{title}</h3>
            {subtitle && <p className="text-indigo-400 font-medium">{subtitle}</p>}
            {company && <p className="text-gray-400 text-sm mt-1">{company}</p>}
          </div>
        </div>
        <Icon 
          Component={isExpanded ? FaChevronUp : FaChevronDown} 
          className="text-indigo-400 text-xl flex-shrink-0"
        />
      </button>
      
      {isExpanded && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: 'auto' }}
          exit={{ opacity: 0, height: 0 }}
          transition={{ duration: 0.3 }}
          className="px-8 pb-8"
        >
          <div className="pt-4 border-t border-indigo-500/20">
            {children}
          </div>
        </motion.div>
      )}
    </motion.div>
  );
};

export default AccordionCard;
